<style scoped>
.collapsable-content {
  margin-left: 1rem;
}

.title {
  display: -webkit-inline-box;
  font-size: 1.1rem;
}

.title .item-container {
  min-width: 1rem;
}
</style>

<template>
  <div>
    <div class="d-flex w-100 justify-content-between">
      <div class="title pointer-cursor" @click="expanded = !expanded">
        <div class="item-container">
          <small><font-awesome-icon :icon="icon" /></small>
        </div>
        {{ title }}
      </div>
      <small><slot name="right-header"></slot></small>
    </div>
    <b-collapse :id="collapseId" v-model="expanded" class="collapsable-content mt-3">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';

library.add([faCaretRight, faCaretDown]);


export default {
  props: {
    collapseId: {
      type: String,
      required: true,
    },
    title: String,
    tip: String,
  },
  data: () => ({
    expanded: false,
  }),
  computed: {
    icon() {
      return this.expanded ? 'caret-down' : 'caret-right';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/CollapsableContainer.vue